/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$border-left: 1px solid v(dateLeftBorder);

:host {
  display: block;
  --borderLeft: #{$border-left};
  @include eon-typography();
}

.#{$prefix}date-container {
  position: relative;
  display: inline-block;
  &.#{$prefix}left {
    align-items: flex-start;
    justify-content: flex-start;
  }

  &.#{$prefix}right {
    align-items: flex-end;
    justify-content: flex-end;
  }
  line-height: 24px;
  .#{$prefix}date {
    font-size: 36px;
    font-weight: $font-weight-black;
    padding-bottom: 4px;
    color: v(dateColor);
    @include for-size(tablet) {
      font-size: 30px;
    }
    @include for-size(phone) {
      font-size: 26px;
      padding-bottom: 2px;
    }
  }

  .#{$prefix}month {
    font-size: 18px;
    font-weight: $font-weight-regular;
    text-transform: uppercase;
    color: v(dateColor);
  }

  .#{$prefix}year {
    color: v(dateColor);
    font-size: 18px;
    font-weight: $font-weight-regular;
    padding-left: 5px;
  }

  .#{$prefix}time {
    color: v(dateColor);
    font-size: 18px;
    font-weight: $font-weight-regular;
    border-left: var(--borderLeft);
    padding-left: 8px;
    text-transform: uppercase;
    margin-left: 9px;
  }

  .#{$prefix}time-zone {
    font-size: 18px;
    font-weight: $font-weight-regular;
    color: v(dateColor);
    padding-left: 5px;
  }

  &.#{$prefix}date-type-one {
    display: flex;
    flex-direction: column;
    .#{$prefix}month-time-wrapper {
      display: flex;
      flex-direction: row;
    }
  }

  &.#{$prefix}date-type-two {
    display: flex;
    flex-direction: column;
    .#{$prefix}month-time-wrapper {
      display: flex;
      flex-direction: column;
      .#{$prefix}time {
        border-left: none;
        padding-left: 0;
        margin-left: 0;
      }
    }
  }

  &.#{$prefix}date-type-three {
    display: flex;
    flex-direction: column;
    .#{$prefix}date-month-wrapper {
      display: flex;
      align-items: flex-end;

      .#{$prefix}date {
        padding-right: 6px;
      }
    }

    .#{$prefix}time {
      border-left: none;
      padding-left: 0;
      margin-left: 0;
    }
  }
}
